/**
 * Shared helpers for capitol-filestore-svc calls.
 *
 * The facade's error envelope is `{ error: { code, message } }` rather than
 * FastAPI's `{ detail }`, so apiRequest's generic extraction misses it;
 * unwrap it here so users see the real reason (e.g. "missing or invalid
 * token") instead of "An unexpected error occurred".
 */

interface FilestoreErrorEnvelope {
  error?: { code?: string; message?: string };
}

export const filestoreErrorMessage = (
  response: { detail?: string; statusCode?: number; data?: unknown },
  fallback: string,
): string => {
  const envelope = response.data as FilestoreErrorEnvelope | null | undefined;
  const message = envelope?.error?.message || response.detail || fallback;
  return response.statusCode
    ? `${message} (HTTP ${response.statusCode})`
    : message;
};

/** Encode a repo-relative path, preserving `/` separators. */
export const encodeFilePath = (filePath: string): string =>
  filePath.split('/').map(encodeURIComponent).join('/');
